import {
	Box,
	HStack,
	VStack,
	Input,
	useDisclosure,
	Textarea,
	Flex,
	Text,
} from '@chakra-ui/react'
import SVGIcon from '../../assets/svgIcons'
import ButtonCTA from '../globalComponents/button'
import { useLanguageContext } from './../../context/locale.context'
import styles from './editUserDetails.module.css'
import ReactSelect from 'react-select'
import { ConfirmationModal } from '../globalComponents/ConfirmationModal'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useState } from 'react'

const BLOOD_GROUP_OPTIONS = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']

const EditUserDetails = ({
	activityInlineData,
	setIsedit,
	editProfileDetails,
	setEditprofileDetails,
	updateEmp,
	bloodGroup,
	setBloodGroup,
	setNameErrorMessage,
	setattachmentURl
}) => {
	const {
		state: { locale },
	} = useLanguageContext()

	const {
		isOpen: isOpenConfirmationModal,
		onOpen: openConfirmationModal,
		onClose: onCloseConfirmationModal,
	} = useDisclosure()

	const { employee_phone_number, employee_phone_country_code } =
		activityInlineData

	const handleChange = e => {
		const { name, value } = e.target
		setEditprofileDetails({ ...editProfileDetails, [name]: value })
	}
	const clearAllErrorMsg = () => {
		setEmailErrorMessage('')
		setAltEmailErrorMessage('')
		setAltPhoneNumErrorMessage('')
		setNameErrorMessage('')
	}

	const onCancel = () => {
		clearAllErrorMsg()
		setIsedit(false)
		setattachmentURl('')
	}

	// const [nameErrorMessage, setNameErrorMessage] = useState('')
	const [emailErrorMessage, setEmailErrorMessage] = useState('')
	const [altEmailErrorMessage, setAltEmailErrorMessage] = useState('')
	const [altPhoneNumErrorMessage, setAltPhoneNumErrorMessage] = useState('')

	const [formValid, setFormValid] = useState(false)
	const [nameValid, setNameValid] = useState(false)
	const [altEmailValid, setAltEmailValid] = useState(false)
	const [altPhoneNumValid, setAltPhoneNumValid] = useState(false)
	const [emailValid, setEmailValid] = useState(false)

	const validateAllField = () => {
		let name_Valid = false
		let email_Valid = false
		let altEmail_Valid = false
		let altPhoneNum_Valid = false

		let empName = editProfileDetails.employee_first_name
		const nameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/i
		if (empName.trim() === '') {
			setNameErrorMessage('Field required')
			name_Valid = false
		}
		else if (empName[empName.length-1]===' '){
			setNameErrorMessage('extra trailing space')
			name_Valid = false
		}
		else if (empName[0]===' '){
			setNameErrorMessage('extra space in beginning')
			name_Valid = false
		}
	    else if (!empName.match(nameRegex)) {
			setNameErrorMessage('Invalid name')
			name_Valid = false
		} 
		else if (empName.length < 3){
			setNameErrorMessage('Name should be minimum 3 characters')
			name_Valid = false
		}
		else {
			setNameErrorMessage('')
			name_Valid = true
		}

		let empEmail = editProfileDetails.employee_email_id
		const emailRegex =
			/^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

		if (empEmail.trim() !== '' && !empEmail.match(emailRegex)) {
			setEmailErrorMessage('Invalid Email Address')
			email_Valid = false
		} else {
			setEmailErrorMessage('')
			email_Valid = true
		}

		let empAltEmail = editProfileDetails.employee_alt_email_id
		const altEmailRegex =
			/^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

		if (empAltEmail.trim() !== '' && !empAltEmail.match(altEmailRegex)) {
			setAltEmailErrorMessage('Invalid Alt Email Address')
			altEmail_Valid = false
		} else {
			setAltEmailErrorMessage('')
			altEmail_Valid = true
		}

		setNameValid(name_Valid)
		setEmailValid(email_Valid)
		setAltEmailValid(altEmail_Valid)

		return name_Valid && email_Valid && altEmail_Valid
	}

	let validPhoneNumber = false
	const validatePhoneNumber = (inputNumber, country, phoneLength) => {
		let inputPhone = inputNumber?.replace(country.dialCode, '')?.trim()
		if(+country.dialCode === 880 || +country.dialCode === 49){
			phoneLength=10
		}
		if(+country.dialCode === 961){
			phoneLength=8
		}
		if(+country.dialCode === 421){
			phoneLength=9
		}
		if (inputNumber && inputPhone === '') {
			validPhoneNumber = false
			return false
		} else if (+country.dialCode === 61) {
			if (inputPhone.length === 9 || inputPhone.length === 10) {
				if (inputPhone.length === 9) {
					if (inputPhone.toString().startsWith('0')) {
						validPhoneNumber = false
						return false
					} else {
						validPhoneNumber = true
						return true
					}
				} else {
					if (inputPhone.toString().startsWith('0')) {
						validPhoneNumber = true
						return true
					} else {
						validPhoneNumber = false
						return false
					}
				}
			} else {
				validPhoneNumber = false
				return false
			}
		} else if (inputPhone.length < phoneLength) {
			validPhoneNumber = false
			return false
		}
		validPhoneNumber = true
		return true
	}

	return (
		<>
			<ConfirmationModal
				isOpen={isOpenConfirmationModal}
				onClose={onCloseConfirmationModal}
				onClickYes={onCancel}
				headerText={locale['Are you sure you want to decline?']}
			/>

			<VStack mt='50px' ml='40px' alignItems='flex-start' spacing='4'>
				<Flex w='90%' alignItems='center'>
					<Box w='26px' h='26px'>
						<SVGIcon
							iconName='CallBigSvg'
							svgProps={{
								width: '24',
								height: '24',
								viewBox: '0 0 24 24',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					<Box w='80%' pl='14px'>
						<Input
							p={0}
							border='none'
							name='employee_phone_num'
							readOnly
							value={`+${employee_phone_country_code} ${employee_phone_number}`}
							cursor='text'
						/>
					</Box>
					<Box mr='2rem'>
						<SVGIcon
							iconName='CheckedSvg'
							svgProps={{
								width: '13',
								height: '12',
								viewBox: '0 0 13 12',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
				</Flex>
				<HStack
					w='90%'
					alignItems='center'
					borderBottom='1px solid rgba(0, 0, 0, 0.25)'
				>
					<Box w='26px' h='26px'>
						<SVGIcon
							iconName='CallBigSvg'
							svgProps={{
								width: '24',
								height: '24',
								viewBox: '0 0 24 24',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					<Box w='80%' pl='14px'>
						<Box
							fontWeight='400'
							fontSize='14px'
							letterSpacing='0.2px'
							color='#030303'
							className={styles.inputEditUserDetails}
						>
							<PhoneInput
								placeholder={locale['Add Alternate Phone Number']}
								_placeholder={{ color: '#828282' }}
								name='employee_alt_phone_num'
								// value={editProfileDetails.employee_alt_phone_num}
								onChange={(value, data, event, formattedValue) => {
									setEditprofileDetails({
										...editProfileDetails,
										employee_alt_phone_num: value.slice(data.dialCode.length),
									})
								}}
								country={'in'}
								onlyCountries={[
									'au',
									'in',
									'us',
									'bd',
									'gb',
									'de',
									'fr',
									'lb',
									'hk',
									'sk',
								]}
								countryCodeEditable={false}
								enableSearch
								buttonStyle={{ border: 'none' }}
								buttonClass='rounded '
								inputStyle={{
									maxWidth: '260px',
									margin: 'auto',
									border: 'none',
									fontSize: '1.125rem',
									fontFamily: 'Avenir',
									backgroundColor: 'white',
								}}
								containerStyle={{
									borderBottom: '1px solid #D9D9D9',
									padding: '2px',
									fontFamily: 'Avenir',
								}}
								isValid={(inputNumber, country, countries) => {
									const originalPhoneNumber = countries.filter(
										val => val.dialCode === country.dialCode
									)[0]?.format
									const phoneNumberWithoutSpecialChars =
										originalPhoneNumber?.replace(/[+() -]/g, '').length
									const phoneLength =
										phoneNumberWithoutSpecialChars - country.dialCode.length
									return validatePhoneNumber(inputNumber, country, phoneLength)
								}}
							/>
						</Box>
					</Box>
				</HStack>

				<HStack
					w='90%'
					alignItems='center'
					borderBottom={
						!!emailErrorMessage
							? '1px solid red'
							: '1px solid rgba(0, 0, 0, 0.25)'
					}
				>
					<Box w='26px' h='26px'>
						<SVGIcon
							iconName='MailBigSvg'
							svgProps={{
								width: '24',
								height: '22',
								viewBox: '0 0 24 22',
							}}
							pathProps={{ fill: !!emailErrorMessage ? 'red' : '#009B76' }}
						/>
					</Box>
					<Box w='80%' pl='14px'>
						<Box
							fontWeight='400'
							fontSize='14px'
							letterSpacing='0.2px'
							color='#030303'
							className={styles.inputEditUserDetails}
						>
							<Input
								p={0}
								border='none'
								placeholder={locale['Add Email Address']}
								_placeholder={{ color: '#828282' }}
								name='employee_email_id'
								value={editProfileDetails.employee_email_id}
								onInput={e => handleChange(e)}
							/>
						</Box>
					</Box>
				</HStack>

				<HStack
					w='90%'
					alignItems='center'
					borderBottom={
						!!altEmailErrorMessage
							? '1px solid red'
							: '1px solid rgba(0, 0, 0, 0.25)'
					}
				>
					<Box w='26px' h='26px'>
						<SVGIcon
							iconName='MailBigSvg'
							svgProps={{
								width: '24',
								height: '22',
								viewBox: '0 0 24 22',
							}}
							pathProps={{ fill: !!altEmailErrorMessage ? 'red' : '#009B76' }}
						/>
					</Box>
					<Box w='80%' pl='14px'>
						<Box
							fontWeight='400'
							fontSize='14px'
							letterSpacing='0.2px'
							color='#030303'
							className={styles.inputEditUserDetails}
						>
							<Input
								p={0}
								border='none'
								placeholder={locale['Add Alternate Email address']}
								_placeholder={{ color: '#828282' }}
								name='employee_alt_email_id'
								value={editProfileDetails.employee_alt_email_id}
								onChange={e => handleChange(e)}
							/>
						</Box>
					</Box>
				</HStack>
				<HStack
					w='90%'
					alignItems='center'
					borderBottom='1px solid rgba(0, 0, 0, 0.25)'
				>
					<Box w='26px' h='26px'>
						<SVGIcon
							iconName='BdayBigSvg'
							svgProps={{
								width: '24',
								height: '24',
								viewBox: '0 0 24 24',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					<Box w='80%' pl='14px'>
						<Box
							fontWeight='400'
							fontSize='14px'
							letterSpacing='0.2px'
							color='#030303'
							className={styles.inputEditUserDetails}
						>
							<Input
								p={0}
								type='date'
								border='none'
								placeholder={locale['Add Birth Date']}
								name='employee_dob'
								value={editProfileDetails.employee_dob}
								onChange={e => {
									handleChange(e)
								}}
							/>
						</Box>
					</Box>
				</HStack>
				<HStack
					w='90%'
					alignItems='center'
					borderBottom='1px solid rgba(0, 0, 0, 0.25)'
				>
					<Box w='26px' h='26px'>
						<SVGIcon
							iconName='BloodGroupBigSvg'
							svgProps={{
								width: '21',
								height: '27',
								viewBox: '0 0 21 27',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					<Box w='80%' pl='14px'>
						<Box
							fontWeight='400'
							fontSize='14px'
							letterSpacing='0.2px'
							color='#030303'
						>
							<ReactSelect
								isMulti={false}
								isSearchable={false}
								options={(BLOOD_GROUP_OPTIONS || []).map(val => {
									return {
										label: val,
										value: val,
									}
								})}
								value={bloodGroup}
								placeholder={locale['Select Blood Group']}
								onChange={e => setBloodGroup(e)}
								styles={{
									control: (baseStyles, state) => ({
										...baseStyles,
										backgroundColor: 'brand.700',
										border: '1px solid rgba(255, 255, 255,0.5)',
										boxShadow: 'none',
										borderRadius: '20px',
										'&:hover': {
											borderColor: 'rgba(255, 255, 255,0.5)',
										},
									}),
									indicatorSeparator: baseStyles => ({
										...baseStyles,
										marginTop: '0px',
										marginBottom: '0px',
									}),
									option: baseStyles => ({
										...baseStyles,
										textTransform: 'uppercase',
										letterSpacing: '2px',
									}),
									valueContainer: baseStyles => ({
										...baseStyles,
										padding: '0px',
									}),
								}}
							/>
						</Box>
					</Box>
				</HStack>

				<HStack
					w='90%'
					alignItems='center'
					borderBottom='1px solid rgba(0, 0, 0, 0.25)'
				>
					<Box w='26px' h='26px'>
						<SVGIcon
							iconName='AddressBigSvg'
							svgProps={{
								width: '19',
								height: '24',
								viewBox: '0 0 19 24',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					<Box w='80%' pl='14px'>
						<Box
							fontWeight='400'
							fontSize='14px'
							letterSpacing='0.2px'
							color='#030303'
							className={styles.textareaEditUserDetails}
						>
							<Textarea
								p={0}
								border='none'
								name='employee_location'
								value={editProfileDetails.employee_location}
								onChange={e => handleChange(e)}
								_placeholder={{ color: '#828282' }}
								placeholder={locale['Add Address Details']}
								size='sm'
							/>
						</Box>
					</Box>
				</HStack>
				<Flex w='90%' justifyContent='space-between'>
					<ButtonCTA
						variant='modalCloseButton'
						onClick={() => {
							openConfirmationModal()
						}}
					>
						{locale['Cancel']}
					</ButtonCTA>
					<ButtonCTA
						variant='modalSubmitButton'
						onClick={() => {
							if (validateAllField()) updateEmp()
						}}
						type='submit'
					>
						{locale['Submit']}
					</ButtonCTA>
				</Flex>
			</VStack>
		</>
	)
}

export { EditUserDetails }
